module.exports = __webpack_public_path__ + "static/3-3ec461889a58d334985b1ec9792db8c9.jpg";